import { render, staticRenderFns } from "./BG.vue?vue&type=template&id=dfc28af8&scoped=true&"
import script from "./BG.vue?vue&type=script&lang=js&"
export * from "./BG.vue?vue&type=script&lang=js&"
import style0 from "./BG.vue?vue&type=style&index=0&id=dfc28af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc28af8",
  null
  
)

export default component.exports